import { FIREBASE_INIT_APP } from './actionTypes';

import axios from '../../API/axiosConfig';

// FIREABSE CREDENTIALS
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// IMPORT CUSTOM HANDLERS
import { updateSurvey } from '../../API/agent';
import { fetchSpecificSurveyData } from './Data';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);
const firebaseFirestore = getFirestore(firebaseApp);

//FILL UP STORE WITH THE FIREBASE METHODS (app, auth, firestore)
export const initializeFirebaseApp = () => {
  return dispatch => {
    dispatch({
      type: FIREBASE_INIT_APP,
      app: firebaseApp,
      auth: firebaseAuth,
      firestore: firebaseFirestore,
    });
  };
};

/**
 * @param {'Brand' | 'Buyer'} surveyType
 * @param {any} data
 * @description calls axios on calulcation api
 */
export const algorithmCalculation = (surveyType, data, dispatch, visibleAgencies) => {
  return new Promise((resolve, reject) => {
    const url = surveyType === 'Brand' ? '/calculations/brand-persona' : '/calculations/buyer-persona';

    axios
      .post(url, data)
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            resolve(result.data.result);

            //Update the survey with calcuated data
            const surveyId = data.persona.id;
            const { Total_Match, Product_Match, Values_Match } = result.data.result.match;

            const totalMatchRounded = Number((Total_Match * 100).toFixed(2));
            const productMatchRounded = Number((Product_Match * 100).toFixed(2));
            const valuesMatchRounded = Number((Values_Match * 100).toFixed(2));
            if (
              data.persona.filter != !!data.filters ||
              data.persona.totalMatch != totalMatchRounded ||
              data.persona.productBenefitsMatch != productMatchRounded ||
              data.persona.socialValueMatch != valuesMatchRounded
            ) {
              const resultData = {
                filter: !!data.filters,
                totalMatch: totalMatchRounded,
                productBenefitsMatch: productMatchRounded,
                socialValueMatch: valuesMatchRounded,
              };
              updateSurvey(surveyType, surveyId, resultData).then(res => {
                if (!res.err) dispatch(fetchSpecificSurveyData(surveyType, visibleAgencies));
              });
            }
          } else {
            reject('An error occured while calulcating the data');
          }
        } else {
          reject('Server didnt respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};

export const brandBuyerComparisonAlgorithmCalculation = (brandPersona, buyerPersona) => {
  return new Promise((resolve, reject) => {
    const url = '/calculations/brand-buyer-compare';

    axios
      .post(url, { brandPersona, buyerPersona })
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            resolve(result.data.result);
          } else {
            reject('An error occured while calulcating the data');
          }
        } else {
          reject('Server didnt respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};

export const consumerAlgorithmCalculation = data => {
  return new Promise((resolve, reject) => {
    const url = '/calculations/consumer-data';

    axios
      .post(url, data)
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            resolve(result.data.result);
          } else {
            reject('An error occured while calulcating the data');
          }
        } else {
          reject('Server didnt respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};

export const marketSizeCalculation = data => {
  return new Promise((resolve, reject) => {
    const url = '/calculations/market-size';

    axios
      .post(url, data)
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            resolve(result.data.result);
          } else {
            reject('An error occured while calculating market size');
          }
        } else {
          reject('Server didnt respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};

export const competitiveSetBrandsAlgorithmCalculation = data => {
  return new Promise((resolve, reject) => {
    const url = '/calculations/selected-brand';

    axios
      .post(url, data)
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            resolve(result.data.result);
          } else {
            reject('An error occurred while calculating the data');
          }
        } else {
          reject('Server did not respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};

export const multipleBrandsAlgorithmCalculation = data => {
  return new Promise((resolve, reject) => {
    const url = '/calculations/multiple-brand';

    axios
      .post(url, data)
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            if (result.data.result.no_data) resolve(result.data.result);
            else {
              const rewampedResults = Object.values(result.data.result).map(value => ({
                ...value.info,
                ...value.average,
                ...value.match,
              }));
              resolve(rewampedResults);
            }
          } else {
            reject('An error occured while calulcating the data');
          }
        } else {
          reject('Server didnt respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};

export const socialMediaAlgorithmCalculation = (data, dispatch, visibleAgencies) => {
  return new Promise((resolve, reject) => {
    const url = '/calculations/social-post';

    axios
      .post(url, data)
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            resolve(result.data.result);

            //Update the survey with calcuated data
            const surveyId = data.socialPost.id;
            const { value, mainStatus } = result.data.result.social_post_data.TotalImpact;
            const impactValue = Math.round(Number((value * 100).toFixed(0)));

            if (
              data.socialPost.filter != !!data.filters ||
              data.socialPost.impact != impactValue ||
              data.socialPost.suggestion != mainStatus
            ) {
              const resultData = {
                filter: !!data.filters,
                impact: impactValue,
                suggestion: mainStatus,
              };
              updateSurvey('social', surveyId, resultData).then(res => {
                if (!res.err) dispatch(fetchSpecificSurveyData('social', visibleAgencies));
              });
            }
          } else {
            reject('An error occured while calulcating the data');
          }
        } else {
          reject('Server didnt respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};

export const brandConsumersAlgorithmCalculation = data => {
  return new Promise((resolve, reject) => {
    const url = '/calculations/brand-consumer';

    axios
      .post(url, data)
      .then(result => {
        if (result.status === 200) {
          if (!result.data.error) {
            resolve(result.data.result);
          } else {
            reject('An error occured while calulcating the data');
          }
        } else {
          reject('Server didnt respond in a regular status');
        }
      })
      .catch(err => {
        reject(err.message);
      });
  });
};
